import {BaseCopyStamp} from '../../utils/BaseCopyStamp';

export class AnimCopyStamp extends BaseCopyStamp {}
